import {BasePqForm} from "biz-ts/src/api/Paging";
import {DeviceMessageType} from "@/model/DeviceMessage";
import {MessageLevel} from "@/model/Message";

export class DmessagePqForm extends BasePqForm {
    deviceId: number
    types: Array<DeviceMessageType>
    levels: Array<MessageLevel>

    constructor() {
        super();
        this.deviceId = -1
        this.types = []
        this.levels = []
    }
}
